import { render } from "./ServerManagement.vue?vue&type=template&id=960528f6&scoped=true"
import script from "./ServerManagement.vue?vue&type=script&lang=js"
export * from "./ServerManagement.vue?vue&type=script&lang=js"

import "./ServerManagement.vue?vue&type=style&index=0&id=960528f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960528f6"]])

export default __exports__